import { Box, Button, Container, Flex, Skeleton, Text, useBreakpointValue } from "@chakra-ui/react";

import BlogCard from "@/components/general/BlogCard";
import BlogCardCarousel from "@/components/general/BlogCardsCarousel";

export const BlogGuia = ({ data }) => {
    // TODO: optimize breakpoint logic (global utility?)
    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });
    const isGreaterThanLg = useBreakpointValue({ base: false, lg: true });
    const isGreaterThanXl = useBreakpointValue({ base: false, xl: true });

    const showSkeleton = () => {
        if (isGreaterThanXl) {
            return (
                <Flex
                    w="100%"
                    h="256px"
                    direction="row"
                    alignItems="center"
                    justifyContent="space-around"
                    gap={{ lg: "10", xl: "5" }}
                    bg="white"
                >
                    <Skeleton w="367px" h="100%" borderRadius="10px" />
                    <Skeleton w="367px" h="100%" borderRadius="10px" />
                    <Skeleton w="367px" h="100%" borderRadius="10px" />
                </Flex>
            );
        } else if (isGreaterThanLg) {
            return (
                <Flex
                    w="100%"
                    h="256px"
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    gap="10"
                    bg="white"
                >
                    <Skeleton w="367px" h="100%" borderRadius="10px" />
                    <Skeleton w="367px" h="100%" borderRadius="10px" />
                </Flex>
            );
        } else if (isGreaterThanMd) {
            return (
                <Flex
                    w="100%"
                    h="256px"
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    gap="10"
                    bg="white"
                >
                    <Skeleton w="367px" h="100%" borderRadius="10px" />
                    <Skeleton w="367px" h="100%" borderRadius="10px" />
                </Flex>
            );
        }
        return (
            <Flex
                w="100%"
                h="256px"
                direction="row"
                alignItems="center"
                justifyContent="center"
                gap="2"
                bg="white"
            >
                <Skeleton w="367px" h="100%" borderRadius="10px" />
            </Flex>
        );
    };

    const redirectPage = (link) => {
        window.open(link, "_blank");
    };

    const cutDescription = (text) => {
        if (!text) return ""; // Manejo de texto undefined/null
        const firstPeriodIndex = text.indexOf(".");
        return firstPeriodIndex >= 0
            ? text.slice(0, firstPeriodIndex + 1) // +1 para incluir el punto
            : text; // Si no hay punto, devuelve el texto completo
    };

    const getDayAndMonth = (blogDate) => {
        const months = [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre",
        ];

        const dateFromArray = new Date(blogDate);
        const day = dateFromArray.getUTCDate();
        const month = months[dateFromArray.getUTCMonth()];

        return { day, month };
    };

    return (
        <Container px={{ base: 4, md: 0 }}>
            <Box my={10} align="center">
                <Text
                    as="h2"
                    fontSize={{ base: "md", md: "lg", lg: "2xl" }}
                    textAlign="center"
                    color="#002B49"
                    fontWeight={600}
                >
                    Blog Guía
                </Text>
                <Text
                    fontSize={{ base: "sm", md: "md", lg: "xl" }}
                    color="#002B49"
                    textAlign="center"
                    my="2"
                    fontWeight="400"
                    as="h3"
                    mx={2}
                >
                    Recomendaciones, guías y consejos para adquirir o rentar tu propiedad
                </Text>
            </Box>
            <Box mb={6} justifyContent="center">
                <Container maxW="6xl" minHeight="500px" mx="auto">
                    {(!data || data.length === 0) && showSkeleton()}
                    {data && data.length > 0 && (
                        <BlogCardCarousel gap={16} isBlogSection={true}>
                            {data.map((item, index) => {
                                const { day, month } = getDayAndMonth(item?.publishDate);

                                return (
                                    <BlogCard
                                        key={index}
                                        title={item?.name}
                                        description={cutDescription(item?.metaDescription)}
                                        date={item?.created}
                                        featuredImage={item?.featuredImage}
                                        postUrl={item?.url}
                                        day={day}
                                        month={month}
                                    />
                                );
                            })}
                        </BlogCardCarousel>
                    )}
                    <Flex justifyContent="center" alignItems="center" my={{ base: 10, md: 20 }}>
                        <Button
                            border="1px solid #002B49"
                            backgroundColor="transparent"
                            width={{ base: "230px", sm: "300px", md: "350px", lg: "400px" }}
                            justifyContent="center"
                            color="#002B49"
                            fontSize={{ base: "xs", sm: "sm", md: "md", lg: "lg" }}
                            fontWeight="400"
                            onClick={() => redirectPage("https://blog.grupoguia.mx/")}
                            rounded="md"
                            _hover={{ bg: "accent.500", color: "white" }}
                        >
                            Ver más entradas de Blog
                        </Button>
                    </Flex>
                </Container>
            </Box>
        </Container>
    );
};
